import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ReportV2Services {
  // get reports v2 List
  getReportsV2List = async (params) => {
    let url = `${Constants.GET_REPORTS_V2}/list?`;
    if (params?.report_id) url += `report_id=${params?.report_id}&`;
    const reportsV2List = await Helpers.get({ url });

    return reportsV2List;
  }

  // filter reports v2 List
  filterReportsV2List = async (params) => {
    const url = `${Constants.GET_REPORTS_V2}/request/submit`;
    const reportsV2List = await Helpers.post({
      url,
      data: params,
    });
    return reportsV2List;
  }

  // get reports v2 List Detail
  getReportsV2ListDetail = async (params) => {
    let url = `${Constants.GET_REPORTS_V2}/request/list?`;
    if (params?.type) url += `report_type=${params?.type}&`;
    if (params?.page) url += `page=${params?.page}&`;
    if (params?.limit) url += `limit=${params?.limit}&`;
    if (params?.report_id) url += `report_id=${params?.report_id}&`;
    if (params?.status) url += `status=${params?.status}&`;
    const reportsV2ListDetail = await Helpers.get({ url });

    return reportsV2ListDetail;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  deleteScheduledReport = async (payload) => {
    const url = `${Constants.GET_REPORTS_V2}/request/delete?`;
    const deletedReport = await Helpers.post({
      url,
      data: payload,
    });

    return deletedReport;
  }
}
export default new ReportV2Services();
